module.exports = __webpack_public_path__ + "img/MEDIA096.fce89c3e.jpg";